import { useAccount } from './api/account';

export const useUserCheckPermission = () => {
  const { data } = useAccount();

  const can = (permission: string): boolean => {
    return data?.permissions?.includes(permission) || false;
  };

  return { can };
};
